<template lang="pug">
.item
  h5.i_body_l {{ title }}
  img(:src="img")
  p.i_body_l {{ content }}
</template>
<script>
export default {
  name: "Item",
  props: {
    title: String,
    img: String,
    content: String,
  },
};
</script>

<style lang="scss" scoped>
.item {
  @include size(18vw, auto);
  max-width: 260px;

  h5 {
    height: 4.86vw;
    border: solid 1.5px $color_blue_btn;
    background-color: #ffffff;
    font-weight: normal;
    text-align: center;
    margin: 0;
    line-height: 4.86vw;
  }

  img {
    margin-top: 20px;
    @include size(100%, 12.5vw);
    max-height: 180px;
  }

  p {
    margin-top: 16px;
    padding-left: 10px;
    padding-right: 10px;
  }
}

@media (max-width: 991px) {
  .item {
    @include size(216px, auto);

    h5 {
      height: 58px;
      line-height: 58px;
    }

    img {
      @include size(100%, 150px);
      max-height: 180px;
    }

    p {
      margin-top: 10px;
      padding-left: 5px;
      padding-right: 5px;
    }
  }
}

@media (max-width: 767px) {
  .item {
    @include size(180px, auto);

    h5 {
      height: 60px;
      line-height: 60px;
    }

    img {
      @include size(100%, 140px);
    }

    p {
      margin-top: 10px;
      padding-left: 5px;
      padding-right: 5px;
    }
  }
}

@media (max-width: 575px) {
  .item {
    @include size(31.25vw, auto);

    h5 {
      height: 10.4vw;
      line-height: 10.4vw;
    }

    img {
      @include size(100%, 24.3vw);
    }

    p {
      margin-top: 1.7vw;
      padding-left: 1vw;
      padding-right: 1vw;
    }
  }
}
</style>
